<template>
  <div class="aaaaa" >
    <!-- 头部部分 -->
    <div class="bbbbb">
      <div ref="search_d">
        <el-row type="flex" class="row-bg">
            <el-button type="primary" @click="newBtn">新增分类</el-button>
            <el-button type="danger" @click="handleDeltes">批量删除</el-button>
        </el-row>
      </div>

      <!-- 表格部分 -->
      <div>
        <el-table
          border
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :height="height"
          :reserve-selection="true"
          @selection-change="handleSelectionChange"
          empty-text="暂无数据"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                border
                ref="childTbale"
                :data="props.row.childList"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="childHandChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  label="序号"
                  type="index"
                  width="50"
                  align="center"
                ></el-table-column>
                <!-- <el-table-column
                  label="封面图像"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="scope.row.logo"
                      :preview-src-list="[scope.row.logo]"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="分拣品类"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">{{
                      scope.row.categoryName
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">{{
                      scope.row.createTime
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.putOn"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changePutOn(scope.row)"
                    >
                    </el-switch
                    >
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="290" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="edit(scope.row)"
                      size="small"
                    >编辑
                    </el-button
                    >
                    <el-button
                      type="text"
                      style="color: red"
                      @click="handleDelte(scope.row)"
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            label="封面图像"
            align="center"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">{{ scope.row.createTime }}</template> -->
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="品类名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.categoryName }}</template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.putOn"
                :active-value="1"
                :inactive-value="0"
                @change="changePutOn(scope.row)"
              >
              </el-switch
              >
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否参加活动" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isActivity" :active-value="1" :inactive-value="0">
              </el-switch></template>
          </el-table-column> -->
          <el-table-column label="操作" width="290" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small"
              >编辑
              </el-button
              >
              <el-button
                type="text"
                style="color: red"
                @click="handleDelte(scope.row)"
              >删除
              </el-button
              >

              <el-button
                slot="reference"
                type="text"
                @click="newSonBtn(scope.row)"
              >新增子类
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.currPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      :title="labelType == 'add' ? '添加' : '编辑'"
      :visible.sync="showDialog"
      width="800px"
    >
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addForm"
        v-if="labelType == 'add'"
      >新增品类
      </el-button>
      <el-form :model="tableForm" ref="tableForm" size="small">
        <el-table
          border
          ref="formData"
          :data="tableForm.formData"
          tooltip-effect="dark"
          style="width: 100%"
          :height="height"
        >
          <el-table-column
            label="分类名称"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="'formData.' + scope.$index + '.categoryName'"
                :rules="rules.categoryName"
              >
                <el-input
                  v-model="scope.row.categoryName"
                  placeholder="请输入"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- <el-table-column label="排序" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item :prop="'formData.' + scope.$index + '.seq'" :rules="rules.seq">
                <el-input v-model="scope.row.seq" placeholder="请输入" onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.putOn" :active-value="1" :inactive-value="0">
              </el-switch></template>
          </el-table-column>
          <el-table-column label="是否参加活动" width="100" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isActivity" :active-value="1" :inactive-value="0">
              </el-switch></template>
          </el-table-column> -->
          <!-- <el-table-column label="商品品类图像" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item :prop="'formData.' + scope.$index + '.bigImg'" :rules="rules.bigImg">
                <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false" :on-success="function (res, file, fileList) {
                  return handleAddBigImgSuccess(file, scope.$index);
                }
                  " :before-upload="beforeBigImg">
                  <img v-if="scope.row.bigImg" :src="scope.row.bigImg" class="avatar" style="width:50px;height:50px" />
                  <i v-else class="el-icon-upload avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </template>
          </el-table-column> -->
          <el-table-column label="封面图" align="center" show-overflow-tooltip v-if="addType == 1">
            <template slot-scope="scope">
              <el-form-item
                :prop="'formData.' + scope.$index + '.logo'"
                :rules="rules.logo"

              >
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadURL"
                  :show-file-list="false"
                  :style="{ marginTop: '20px' }"
                  :on-success="
                    function (res, file, fileList) {
                      return handleAddUploadSuccess(file, scope.$index);
                    }
                  "
                  :before-upload="beforeUpload"
                >
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    class="avatar"
                    style="width: 50px; height: 50px; text-align: center;"
                  />
                  <i v-else class="el-icon-upload avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="deleteFromData(scope.$index)"
                size="small"
              >删除
              </el-button
              >
            </template
            >
          </el-table-column>
        </el-table>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="cancelForm('tableForm')"
        >取消</el-button
        >
        <el-button size="small" type="primary" @click="handleSave('tableForm')"
        >确定</el-button
        >
      </span>
    </el-dialog>

    <editVue
      :items="items"
      :showEditDialog="showEditDialog"
      @saveItem="saveItem"
      @cancelItem="cancelItem"
    ></editVue>
  </div>
</template>

<script>
import editVue from './components/edit.vue'

export default {
  components: { editVue },
  data () {
    return {
      labelType: 'add',
      // 添加分类类型 1-父类 2-子类
      addType: 1,
      // 如果添加分类类型是子类，保存父类编码和名称
      parentCode: '',
      parentName: '',
      showEditDialog: false,
      items: [],
      total: 0,
      queryInfo: {
        pageSize: 10,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      tableForm: {
        formData: [
          {
            categoryName: '',
            logo: '',
            bigImg: '',
            putOn: 1,
            isActivity: 0,
            seq: 0
          }
        ]
      },
      rules: {
        categoryName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        logo: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'change'
          }
        ]
      },
      showDialog: false,
      tableData: [],
      childList: [],
      height: window.innerHeight - 200, // 表格高度
      headerHeight: 0,
      ids: []
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 修改分类上下架状态
    changePutOn (row) {
      const message = row.putOn === 1 ? '上架成功' : '已下架'
      this.$http
        .post('/productCategory/upDownStatus', {
          id: row.id,
          putOn: row.putOn
        })
        .then((response) => {
          if (response.data.code === 200) {
            this.$message({
              message: message,
              type: 'success'
            })
            this.getList()
          }
        })
        .catch((error) => {
          console.error('There was an error!', error)
        })
      console.log('3232', row)
    },
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },

    async saveItem (val) {
      var that = this
      that.$http
        .post('/productCategory/update', val[0])
        .then(function (response) {
          if (response.data.code == 200) {
            that.$message({
              message: '保存成功!',
              type: 'success'
            })
            that.showEditDialog = false
            that.getList()
          }
        })
    },
    cancelItem () {
      this.showEditDialog = false
    },
    // 获取数据
    getList () {
      var that = this
      that.$http
        .post('/productCategory/listParent', that.queryInfo)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.total = response.data.data.count
            that.queryInfo.currPage = response.data.data.currPage
            that.tableData = response.data.data.data
            that.childList = response.data.data.data.childList
          }
        })
    },
    cancelForm () {
      this.showDialog = false
    },
    // 保存
    handleSave (formName) {
      var that = this

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // that.tableForm.formData.seq = Number(that.form.seq);

          const newArr = that.tableForm.formData.map(function (item) {
            return {
              level: item.level,
              parentCode: item.parentCode,
              parentName: item.parentName,
              categoryName: item.categoryName,
              logo: item.logo,
              bigImg: item.bigImg,
              putOn: item.putOn,
              isActivity: item.isActivity,
              seq: Number(item.seq),
              merchantCode:localStorage.getItem('merchantCode')
            }
          })
          // console.log(newArr)

          that.$http
            .post('/productCategory/saveBatch', {productCategoryList:newArr})
            .then(function (response) {
              if (response.data.code == 200) {
                that.$notify.success({
                  title: '提示',
                  message: '保存成功',
                  showClose: true
                })
                that.showDialog = false
                that.getList()
              } else {
                that.$notify.info({
                  title: '提示',
                  message: response.data.message,
                  showClose: true
                })
              }
            })
            .catch(function (error) {
            })
        } else {
          // console.log("error submit!!");
          return false
        }
      })
    },

    // 修改
    async edit (row) {
      // var that = this;
      // this.showDialog = true;
      // this.labelType = "edit";
      this.showDialog = false
      this.showEditDialog = true
      const res = await this.$http.post('/productCategory/queryOne', {
        id: row.id
      })

      if (res.data.code == 200) {
        this.items = [res.data.data]
        console.log(this.items, 349)
      }
    },
    // 批量删除
    async handleDeltes () {
      var that = this
      if (this.ids.length == 0) {
        this.$message.error('请选择要删除的分类')
      } else {
        const confirmResult = await this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch((err) => err)
        if (confirmResult === 'confirm') {
          that.$http
            .post('/productCategory/deleteByIds', { ids: this.ids })
            .then(function (res) {
              if (res.data.code == 200) {
                that.$notify.success({
                  title: '提示',
                  message: '删除成功',
                  showClose: true
                })
                that.getList()
              } else {
                that.$notify.info({
                  title: '提示',
                  message: res.data.message,
                  showClose: true
                })
              }
            })
        }
      }
    },
    // 删除
    async handleDelte (row) {
      var that = this
      console.log(Number(row.id))

      // return;
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        that.$http
          .post('/productCategory/delete', { id: row.id })
          .then(function (res) {
            if (res.data.code == 200) {
              that.$notify.success({
                title: '提示',
                message: '删除成功',
                showClose: true
              })
              that.getList()
            } else {
              that.$notify.info({
                title: '提示',
                message: res.data.message,
                showClose: true
              })
            }
          })
      }
    },

    // 新增分类按钮
    newBtn () {
      this.labelType = 'add'
      this.addType = 1
      this.showDialog = true
      this.tableForm.formData = [
        {
          level: 1,
          categoryName: '',
          logo: '',
          bigImg: '',
          putOn: 1,
          isActivity: 0
        }
      ]
    },

    // 新增子类按钮
    newSonBtn (row) {
      this.labelType = 'add'
      this.addType = 2
      this.showEditDialog = false
      this.parentCode = row.categoryCode
      this.parentName = row.categoryName
      this.showDialog = true
      this.tableForm.formData = [
        {
          level: 2,
          parentCode: row.categoryCode,
          parentName: row.categoryName,
          categoryName: '',
          logo: '',
          bigImg: '',
          putOn: 1,
          isActivity: 0
        }
      ]
    },

    // 编辑按钮
    editBtn (row) {
      this.labelType = 'edit'
      this.showDialog = true
      this.tableForm.formData = [
        {
          level: 2,
          parentCode: row.categoryCode,
          parentName: row.categoryName,
          categoryName: '',
          logo: '',
          bigImg: '',
          putOn: 1,
          isActivity: 0
        }
      ]
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },
    // 全选
    handleSelectionChange (val) {
      var idList = []
      val.map((item) => {
        return idList.push(item.id)
      })
      this.ids = idList
      console.log(this.ids)
    },
    childHandChange (val) {
      this.ids = val.id
    },

    // 图片上传成功处理
    handleAddUploadSuccess (file, index) {
      this.tableForm.formData[index].logo = file.response.data.url
      this.$forceUpdate() // 触发强制刷新
    },
    handleAddBigImgSuccess (file, index) {
      this.tableForm.formData[index].bigImg = file.response.data.url
      this.$forceUpdate() // 触发强制刷新
    },

    // 编辑图片
    editBigImg (file) {
      this.tableForm.formData[index].bigImg = file.response.data.url
      this.$forceUpdate() // 触发强制刷新
    },

    // 新增品类
    addForm () {
      if (this.addType == 1) {
        this.tableForm.formData.push({
          level: 1,
          categoryName: '',
          logo: '',
          bigImg: '',
          putOn: 1,
          isActivity: 0
        })
      } else {
        this.tableForm.formData.push({
          level: 2,
          parentCode: this.parentCode,
          parentName: this.parentName,
          categoryName: '',
          logo: '',
          bigImg: '',
          putOn: 1,
          isActivity: 0
        })
      }
    },
    deleteFromData (index) {
      console.log(index)
      this.$confirm('请是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            this.tableForm.formData.splice(index, 1)
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
          } else {
            this.$message({
              message: '已取消删除操作',
              type: 'warning'
            })
          }
        }
      })
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
    beforeBigImg (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    }
  }
}
</script>
<style lang="less" scoped>
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
